define('views/lib/Podio.Views.ProvidersMatrix',['require','translate','underscore','jquery','lib/backbone/Backbone.PodioView','jst!shared/_tab_providers','jst!shared/_provider'],function(require) {

  var t = require('translate');
  var _ = require('underscore');
  var $ = require('jquery');
  var ViewPodioBase = require('lib/backbone/Backbone.PodioView');

  var jstTabProviders = require('jst!shared/_tab_providers');
  var jstProvider = require('jst!shared/_provider');

  return ViewPodioBase.extend({
    podioEvents : {
      'click default ul.providers li' : 'onProviderClick'
    },

    initialize : function(options) {

      _.bindAll(this, 'render', 'renderProviders', 'onProviderClick');

      this._super();

      this.elm = $(this.el);
      this.elmList = null;
      this.eventBridge = options.eventBridge;

      this.model.bind('reset', this.renderProviders);
      this.model.bind('change', this.renderProviders);

      this.hasOptions = false;

      this.descriptionText = this.options.description || t('Choose a provider. #provider-matrix');
    },

    render : function() {

      this.elmTab = $(this.getTemplate(jstTabProviders, {
        description: this.descriptionText
      }));

      this.elmTab.appendTo( this.elm );

      this.elmList = this.elmTab.find('ul.providers');

      return this;
    },

    renderProviders : function() {
      var html = [];
      var self = this;

      _.each(this.model.models, function(provider) {

        if (provider.get('name') === 'legacy_google') { return; }

        var providerHtml = self.getTemplate(jstProvider, {
          provider: provider,
          capability: self.options.capability
        });

        html.push(providerHtml);

      });

      this.elmList.append( html.join('') );
      this.hideLoader();

    },

    dispose: function() {
      this.elm.undelegate('ul.providers li', 'click', this.onProviderClick);
      this.model.unbind('reset', this.renderProviders);
      this.model.unbind('change', this.renderProviders);
    },

    hide : function() {
      this.elmTab.addClass('hidden');
    },

    show : function() {
      this.elmTab.removeClass('hidden');
      this.elmTab.removeClass('minimized');
    },

    showLoader : function() {
      this.elm.addClass('loading-overlay-small');
    },

    hideLoader : function() {
      this.elm.removeClass('loading-overlay-small');
    },

    onProviderClick : function(elmTarget, e) {

      var providerName = elmTarget.data('provider-name');
      this.eventBridge.trigger('connectService', providerName);

    }

  });


});

